import React, { useState } from 'react';
import { BRAND_NAME } from '../constants';
import { Twitter, Mail, Send } from 'lucide-react';
import LegalModal from './LegalModal';

const Footer: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'legal' | 'privacy' | 'cookies'>('legal');

  const openModal = (type: 'legal' | 'privacy' | 'cookies') => {
    setModalType(type);
    setModalOpen(true);
  };

  return (
    <footer id="contact" className="bg-slate-950 border-t border-slate-900 pt-20 pb-12 scroll-mt-28 relative">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-20">
          <div>
            <h3 className="text-lg font-medium text-white mb-4 tracking-wider uppercase">{BRAND_NAME}</h3>
            <p className="text-slate-500 text-sm font-light max-w-xs">
              Más de 8 años de trayectoria. Gestión de capital enfocada en evitar riesgos y maximizar la rentabilidad del análisis de mercado.
            </p>
          </div>
          
          <div className="flex gap-4">
            <a href="https://x.com/carrionbet" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="p-3 border border-slate-800 text-slate-400 hover:text-white hover:border-sage-400 transition-all">
              <Twitter size={18} strokeWidth={1.5} />
            </a>
            <a href="https://t.me/CarrionBET" target="_blank" rel="noopener noreferrer" aria-label="Telegram" className="p-3 border border-slate-800 text-slate-400 hover:text-white hover:border-sage-400 transition-all">
              <Send size={18} strokeWidth={1.5} />
            </a>
            <a href="mailto:contacto@carrionbet.com" aria-label="Email" className="p-3 border border-slate-800 text-slate-400 hover:text-white hover:border-sage-400 transition-all">
              <Mail size={18} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="border-t border-slate-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-600 text-xs font-mono">
            © {new Date().getFullYear()} {BRAND_NAME}. ALL RIGHTS RESERVED.
          </p>
          <div className="flex gap-8 text-xs text-slate-600 font-mono uppercase tracking-wider">
             <button onClick={() => openModal('legal')} className="hover:text-sage-400 transition-colors uppercase">Aviso Legal</button>
             <button onClick={() => openModal('privacy')} className="hover:text-sage-400 transition-colors uppercase">Privacidad</button>
             <button onClick={() => openModal('cookies')} className="hover:text-sage-400 transition-colors uppercase">Cookies</button>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-slate-900/50 text-center">
            <p className="text-[10px] text-slate-700 max-w-3xl mx-auto leading-relaxed font-mono">
                DISCLAIMER: Las inversiones deportivas conllevan riesgos. El rendimiento pasado no garantiza resultados futuros. 
                El contenido es puramente informativo.
            </p>
        </div>
      </div>

      {/* Legal Popups */}
      <LegalModal 
        isOpen={modalOpen} 
        onClose={() => setModalOpen(false)} 
        type={modalType} 
      />
    </footer>
  );
};

export default Footer;